import { Summary } from '../../../../types';
import { InceptHeader } from '../../../constants/InceptHeader';
import { ConstructGet } from '../../../types/ConstructGet';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { SUMMARIES_BASE_PATH } from '../constants/summariesBasePath';

export const getSummaries = async (
  constructGet: ConstructGet,
  definitionName: string,
  template: string,
): Promise<NonPaginatedResponse<Summary[]> | undefined> =>
  constructGet(`${SUMMARIES_BASE_PATH}`, {
    params: { template },
    headers: {
      [InceptHeader.DefinitionName]: definitionName,
    },
  });
